import { render } from "./UnderWeightedVehicleReport.vue?vue&type=template&id=2d4909bc&ts=true&lang=pug"
import script from "./UnderWeightedVehicleReport.vue?vue&type=script&lang=ts"
export * from "./UnderWeightedVehicleReport.vue?vue&type=script&lang=ts"

import "./UnderWeightedVehicleReport.vue?vue&type=style&index=0&id=2d4909bc&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__